import { LabelOutlined } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

export function TagsView({
  tags,
}: {
  tags: Array<{ id: number; name: string }>;
}) {
  return (
    <Box
      display={'flex'}
      justifyContent={'flex-start'}
      alignItems={'center'}
      flexWrap={'wrap'}
      gap={1}
      marginBottom={1}
    >
      {tags.map((tag) => (
        <Stack
          key={tag.id}
          sx={{
            padding: '2px 10px',
            border: '1px solid white',
            borderRadius: '5px',
          }}
        >
          <Typography sx={{ color: ColorsRaw.basic.White, fontSize: 14 }}>
            {tag.name}
          </Typography>
        </Stack>
      ))}
      <LabelOutlined />
    </Box>
  );
}
